import { useQuery } from '@tanstack/react-query';

import { BaseError } from '../../helpers/BaseError';

import { RewardFunction } from '../../models/formula.model';

import API from '../../services/api';

import rewardFunctionKeys from './_queryKeys';

const getRewardFunctions = async (): Promise<RewardFunction[]> => {
    const { data } = await API.getRewardFunctions();
    return data;
};

export default function useRewardFunctions() {
    return useQuery<RewardFunction[], BaseError>({
        queryKey: rewardFunctionKeys.all,
        queryFn: getRewardFunctions,
        staleTime: 60 * 60,
    });
}
